import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { siteMap } from "internal-sitemap";
import SubscriptionType from "organisms/enums/subscription-type";
import React from "react";
import { useHistory } from "react-router";
import { t } from "utilities/localization-utils";
import { RouteUtils } from "utilities/route-utils";
import SubscriptionTypeUtils from "utilities/subscription-type-utils";

const BASE_CSS_CLASS = "c-try-link-footer";

const TryLinkFooter = () => {
    const history = useHistory();
    const freeAccessRoute = RouteUtils.getUrl(
        siteMap.signup.registerPlanSelected,
        {
            subscriptionType: SubscriptionTypeUtils.toRouteParam(
                SubscriptionType.FreeTrial
            ),
        }
    );
    return (
        <div className={BASE_CSS_CLASS}>
            <div className={`${BASE_CSS_CLASS}__taglineWrapper`}>
                {/* Re-add once we're ready for a tagline in the footer */}
                {/* <Paragraph cssClassName={`${BASE_CSS_CLASS}__tagline`}>
                    {t("try-link-footer--tagline")}
                </Paragraph>
                <Button size={ButtonSizes.Small} style={ButtonStyles.Secondary}>
                    {t("learnMore")}
                </Button> */}
            </div>
            <Button
                style={ButtonStyles.Secondary}
                onClick={() => history.push(freeAccessRoute)}>
                {t("tryAFreeTrial")}
            </Button>
        </div>
    );
};

export default TryLinkFooter;
